import * as React from "react";
import { useTranslation } from "react-i18next";
import { Box, Typography } from "@mui/material";
import { getUrl } from "@aws-amplify/storage";
import { VisuallyHiddenInput } from "../helpers/helpers";

export default function ImageUpload({ imageKey, uploadImage, productId }) {
  const [imageUrl, setImageUrl] = React.useState("");
  const { t } = useTranslation();

  async function getImage() {
    if (!imageKey) {
      setImageUrl("");
      return;
    }
    let imgUrl = "";
    try {
      const result = await getUrl({
        key: imageKey,
        options: {
          accessLevel: "public",
        },
      });
      imgUrl = result.url;
    } catch (error) {
      console.log(error);
      imgUrl = "";
    }
    setImageUrl(imgUrl);
  }

  React.useEffect(() => {
    getImage();
  }, [imageKey]);

  return (
    <Box
      component="label"
      sx={{
        "&:hover": {
          cursor: "pointer",
          transform: "scale(1.05)",
        },
      }}
      onChange={(e) => {
        uploadImage(e, productId);
      }}
    >
      <VisuallyHiddenInput type="file" />
      {imageUrl !== "" ? (
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            userSelect: "none",
          }}
        >
          <Box
            component="img"
            draggable={false}
            sx={{
              width: 120,
              height: "auto",
              maxHeight: 120,
              objectFit: "contain",
            }}
            alt={"img"}
            src={imageUrl}
          />
        </Box>
      ) : (
        <Typography
          sx={{
            fontSize: 15,
            userSelect: "none",
            border: 1,
            borderRadius: 2,
            p: 1,
            borderColor: "#999",
            color: "#999",
          }}
        >
          {t("noImageUploaded")}
        </Typography>
      )}
    </Box>
  );
}
